module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/video-5e968bf318039b112a9ae22d894127d6.svg";